import { DEFAULT_SLOT_NAME } from "../../lib/constants.js";
import _sfc_main$1 from "./code_editor_indent.vue.js";
import _sfc_main$2 from "./code_editor_element.vue.js";
import _sfc_main$3 from "./code_editor_input.vue.js";
import { Fragment, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, openBlock, renderSlot, toDisplayString, unref, withCtx } from "vue";
import { camelCase } from "change-case";
//#region src/components/code_editor/code_editor_slot.vue
var _hoisted_1 = { class: "dtc-scheme__class" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorSlot" }, {
	props: {
		name: {
			type: String,
			default: DEFAULT_SLOT_NAME
		},
		indentLevel: {
			type: Number,
			default: 1
		},
		bindings: {
			type: Array,
			default: void 0
		},
		content: {
			type: String,
			default: ""
		}
	},
	emits: ["update:options"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const scopeString = computed(() => {
			if (!props.bindings?.length || !props.content) return "";
			const used = props.bindings.map((b) => camelCase(b.name)).filter((name) => props.content.includes(name));
			if (!used.length) return "";
			return `{ ${used.join(", ")} }`;
		});
		const emit = __emit;
		function onInput(e) {
			emit("update:options", (options) => {
				options.slots[props.name] = e.target.textContent;
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(_sfc_main$1, { level: __props.indentLevel }, {
				default: withCtx(() => [__props.name !== unref("default") ? (openBlock(), createBlock(_sfc_main$2, {
					key: 0,
					"tag-name": "template"
				}, {
					opening: withCtx(() => [_cache[0] || (_cache[0] = createElementVNode("span", null, "\xA0", -1)), createElementVNode("span", _hoisted_1, [createTextVNode("#" + toDisplayString(__props.name), 1), scopeString.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createTextVNode("=\"" + toDisplayString(scopeString.value) + "\"", 1)], 64)) : createCommentVNode("", true)])]),
					default: withCtx(() => [createVNode(_sfc_main$1, { level: __props.indentLevel }, {
						default: withCtx(() => [createVNode(_sfc_main$3, { onInput }, {
							default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
							_: 3
						})]),
						_: 3
					}, 8, ["level"])]),
					_: 3
				})) : (openBlock(), createBlock(_sfc_main$3, {
					key: 1,
					onInput
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				}))]),
				_: 3
			}, 8, ["level"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_slot.vue.js.map